import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Popover, Icon, Tooltip } from '@ets/design-system';
import { useSelector } from '_common/hooks';
import { ToggleMonochrome } from '_common/components';
import { selectAccounts } from 'Auth/redux/localStorageSlice';
import { useGetCurrentUserQuery } from '_common/services/api/authority';

import styles from './ChangeTenantDropdown.module.scss';
import { LocalStorage } from '_common/utils';

const ChangeTenantDropdown = () => {
  const { data: currentUser } = useGetCurrentUserQuery();
  const expanded = useSelector((state) => state.sidebar.expanded);
  const accounts = useSelector(selectAccounts);
  const [open, setOpen] = useState(false);

  const name = currentUser?.other.tenants?.find((tenant) => tenant.current)?.name ?? '';

  const handleChangeTenant = (tenant: NonNullable<UserProfile['other']['tenants']>[number]) => {
    if (tenant.current || !currentUser) {
      return;
    }
    if (tenant.name && tenant.url?.startsWith(window.location.origin)) {
      LocalStorage.setTenant(tenant.name);
      window.location.href = tenant.url;
    } else {
      const device = accounts[currentUser.profile.id].device;
      const token = accounts[currentUser.profile.id].token;
      window.location.href = `${tenant.url}auth/redirect/ok/${token}/${device}`;
    }
  };

  if (!currentUser?.other.tenants) {
    return null;
  }
  if (currentUser?.other.tenants.length <= 0) {
    return null;
  }
  return (
    <>
      <Popover.Root placement="right-start" open={open} onOpenChange={() => setOpen(!open)}>
        <Popover.Trigger>
          <Tooltip content={name} visible={!expanded} placement="right" testId="toggle-change">
            <ToggleMonochrome
              expanded={expanded}
              iconProps={expanded ? undefined : { icon: 'server' }}
              suffix={expanded ? 'angles-up-down' : undefined}
              isToggled={open}
              margin="0 0 1rem 0"
              testId="toggle-change-tenant-monochrome"
              onClick={() => setOpen(!open)}
            >
              {name}
            </ToggleMonochrome>
          </Tooltip>
        </Popover.Trigger>
        <Popover.Content testId="change-tenant">
          <div className={styles.menuContainer}>
            <div className={`${styles.header} ${styles.item}`}>
              <FormattedMessage id="templates.changeTenant" />
            </div>
            <div className={styles.optionsContainer}>
              {currentUser.other.tenants.map((tenant) => (
                <div
                  className={styles.item}
                  key={tenant.url}
                  onClick={() => handleChangeTenant(tenant)}
                  data-testid={`${tenant.name}-dropdown-item`}
                >
                  <div className={styles.label}>{tenant.name}</div>
                  {tenant.current && (
                    <Icon
                      icon="location-dot"
                      color="primary"
                      size="3"
                      testId={`${tenant.name}-dropdown-item`}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        </Popover.Content>
      </Popover.Root>
    </>
  );
};

export default ChangeTenantDropdown;
